import {DrawerProps} from '@mantine/core';
import {RecordForm} from "../forms/RecordForm.tsx";
import {CustomerSubscription, SubscriptionItem} from "../types.ts";
import {PlatformDrawer} from '@flexinet/ui-components';

export const FormDrawer = (
    {
        record,
        handleSubmit,
        opened,
        onClose,
        ...rest
    }: DrawerProps & {
        record: CustomerSubscription,
        handleSubmit: (values: CustomerSubscription) => void
    }) => {

    const title = record?.id ? `Edit Subscription` : `Add Subscription`;

    const handleFormSubmit = async (values: CustomerSubscription) => {
        if (values.items?.items) {
            values.items.items = values.items.items.map((item: SubscriptionItem) => {
                return {
                    id: item.id || '',
                    subscriptionId: values.id || '',
                    priceId: item.priceId,
                    quantity: Number(item.quantity)
                } as SubscriptionItem;
            });
        }
        await handleSubmit(values);
        onClose();
    };

    return (
        <PlatformDrawer
            opened={opened}
            onClose={onClose}
            title={title}
            {...rest}
        >
            <RecordForm
                record={record}
                handleSubmit={handleFormSubmit}
                handleCancel={onClose}
            />
        </PlatformDrawer>
    );
};
